/* PDP — galeria de sugestão em ABAS (2026-07-27)
   1) Abas: VOCÊ TAMBÉM VAI GOSTAR | VISTOS RECENTEMENTE
   2) Carrosséis com setas sobrepostas
   3) Vistos recentemente via localStorage (aba só aparece se houver itens) */
(function(){
  function initCarousel(panel){
    var track = panel.querySelector('[data-pdp-carousel-track]');
    var prev = panel.querySelector('[data-pdp-carousel-prev]');
    var next = panel.querySelector('[data-pdp-carousel-next]');
    if (!track || !prev || !next) return;

    if (panel._carouselBound) {
      if (panel._updateArrows) setTimeout(panel._updateArrows, 50);
      return;
    }
    panel._carouselBound = true;

    function scrollByDir(dir){
      var card = track.querySelector('.pdp-related__card');
      var step = card ? card.offsetWidth + 12 : track.clientWidth * 0.5;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    function updateArrows(){
      var max = track.scrollWidth - track.clientWidth - 2;
      var overflow = track.scrollWidth > track.clientWidth + 4;
      prev.style.display = overflow ? '' : 'none';
      next.style.display = overflow ? '' : 'none';
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    panel._updateArrows = updateArrows;
    prev.addEventListener('click', function(){ scrollByDir(-1); });
    next.addEventListener('click', function(){ scrollByDir(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 100);
  }

  function activateTab(sec, key){
    sec.querySelectorAll('[data-pdp-tab]').forEach(function(t){
      t.classList.toggle('is-active', t.getAttribute('data-pdp-tab') === key);
    });
    sec.querySelectorAll('[data-pdp-panel]').forEach(function(p){
      var on = p.getAttribute('data-pdp-panel') === key;
      p.classList.toggle('is-active', on);
      if (on) initCarousel(p);
    });
  }

  /* === Vistos recentemente — localStorage === */
  var STORAGE_KEY = 'pdpRecentlyViewed';
  var MAX_ITEMS = 10;

  function loadRecent(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e){ return []; }
  }
  function saveRecent(list){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS))); } catch(e){}
  }
  function trackCurrent(){
    var p = window.pdpCurrentProduct;
    if (!p || !p.handle) return;
    var list = loadRecent();
    list = list.filter(function(x){ return x.handle !== p.handle; });
    list.unshift(p);
    saveRecent(list);
  }
  function formatBRL(cents){
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    var v = (cents/100).toFixed(2).replace('.', ',');
    var parts = v.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }
  function renderRecent(){
    var sec = document.querySelector('[data-pdp-tabbed]');
    var panel = document.querySelector('[data-pdp-recent]');
    if (!sec || !panel) return;
    var trackEl = panel.querySelector('[data-pdp-recent-track]');
    if (!trackEl) return;
    var list = loadRecent();
    var currentHandle = window.pdpCurrentProduct && window.pdpCurrentProduct.handle;
    var filtered = list.filter(function(x){ return x.handle && x.handle !== currentHandle; });
    if (filtered.length === 0) return;
    var html = '';
    filtered.forEach(function(p){
      var price = p.price ? formatBRL(p.price) : '';
      var installment = p.price ? formatBRL(Math.round(p.price / 4)) : '';
      html += '<a href="' + p.url + '" class="pdp-related__card" data-pdp-related-handle="' + p.handle + '">' +
              '<div class="pdp-related__card-imgwrap"><img src="' + (p.featuredImage || '') + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>' +
              '<div class="pdp-related__card-name">' + (p.title || '') + '</div>' +
              '<div class="pdp-related__card-price"><strong>' + price + '</strong><span>4x ' + installment + '</span></div>' +
              '</a>';
    });
    trackEl.innerHTML = html;

    var tabBtn = sec.querySelector('[data-pdp-recent-tab]');
    if (tabBtn) tabBtn.hidden = false;

    var hasCategory = !!sec.querySelector('[data-pdp-panel="category"]');
    if (!hasCategory) {
      sec.style.display = '';
      activateTab(sec, 'recent');
    } else if (panel.classList.contains('is-active')) {
      initCarousel(panel);
    }
  }

  function start(){
    trackCurrent();
    document.querySelectorAll('[data-pdp-tabbed]').forEach(function(sec){
      sec.querySelectorAll('[data-pdp-tab]').forEach(function(btn){
        btn.addEventListener('click', function(){ activateTab(sec, btn.getAttribute('data-pdp-tab')); });
      });
      sec.querySelectorAll('.pdp-related__panel.is-active').forEach(initCarousel);
    });
    renderRecent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
